<template>
  <div>
   <v-select
    autocomplete
    outlined
    :loading="isLoading"
    :item-text="i => i.name"
    cache-items
    required
    return-object
    :items="organizations"
    :search-input.sync="search"
    v-model="localOrganization"
    @input="organizationChanged(localOrganization)"
  ></v-select>
  </div>
</template>

<script>
import loading from '../mixins/loading';
import organizationSelectors from './organizationSelectors';

export default {
  name: 'OrganizationSelect',
  mixins: [loading, organizationSelectors],
};
</script>
